<template>
  <div class="site-layout">
    <SiteHeader />
    <HeroCarousel v-if="isHome" />
    <main class="site-main">
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import HeroCarousel from '@/components/HeroCarousel.vue'

export default {
  name: 'MainLayout',
  components: { SiteHeader, SiteFooter, HeroCarousel },
  computed: {
    isHome() {
      return this.$route.path === '/'
    }
  }
}
</script>

<style scoped>
.site-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.site-main {
  flex: 1;
}
</style>
